import { MenuItem } from '@smartsheet/lodestar-core';
import React from 'react';

const navigateToHelp = () => {
  window.open(
    'https://help.smartsheet.com/articles/2481997-troubleshoot-workflows-with-run-log',
    '_blank'
  );
};

export const runLogMenuOptions: ReturnType<typeof MenuItem>[] = [
  <MenuItem key="panel-option-1" onClick={navigateToHelp}>
    Help
  </MenuItem>,
];
